module.exports = __webpack_public_path__ + "img/L_320_325.c147c8a1.png";